import { render, staticRenderFns } from "./springFExchangeRecord.vue?vue&type=template&id=2699384c&scoped=true"
import script from "./springFExchangeRecord.vue?vue&type=script&lang=ts"
export * from "./springFExchangeRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699384c",
  null
  
)

export default component.exports